import { finish, error } from '../../../modules/customers/actions/get-counters';

import api from '../../../api';

export function request(dispatch, { id }) {
    api.get('/customers/' + id + '/counters', void 0, { cache: true }).then(
        (data) => dispatch(finish(id, data)),
        ({ errors }) => dispatch(error(id, errors))
    );
}
